import React from 'react';
import './ConnectCustomers.css';

const ConnectCustomers = () => {
  return (
    <section className="header-block front-hero">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <h1>
              Connect with customers at every step of their journey
            </h1>
            <div className="description">
              <p>
                Sinch provides everything you need to message, email, or call your customers at scale. From user verification to omnichannel campaigns, our APIs and applications have you covered.
              </p>
            </div>
            <div className="btn-group">
              <div className='connect_page_first_btn'>

                  Talk to an expert
              </div>
              <div className='connect_page_second_btn'>
                  Try for free
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConnectCustomers;